import { React } from 'react';
import { Form } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { US_STATE_NAMES } from '../../common/states';

const StateFormSelect = props => {
  const { defaultValue, onChange } = props;

  // One shared source of state names (see common/states.js) so this form and
  // the site detail view never disagree on which states exist.
  const states = US_STATE_NAMES;

  return (
    <Form.Select defaultValue={defaultValue} onChange={onChange} required>
      {defaultValue === '' && (
        <option value="" selected disabled>
          Select a state
        </option>
      )}
      {states.map(state => (
        <option value={state} key={state}>
          {state}
        </option>
      ))}
    </Form.Select>
  );
};

StateFormSelect.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StateFormSelect;
